module.exports = __webpack_public_path__ + "img/9d7fe.7f739944.svg";